export const API = {
    QR: {
      GENERATE: '/api/generate-qr',
      STATUS: '/api/qr-status',
    },
    STRIPE: {
      PAYMENT_INTENT: '/api/admin/stripe-config/create-stripe-payment-intent',
      CONFIG: '/api/admin/stripe-config',
    },
    REGISTRATION: {
      FORM_DATA: '/api/register-form-data',
    },
    BANK: {
      CONFIG: '/api/admin/bank-config',
      PUBLIC_AVAILABILITY: '/api/public/payment-methods/bank',
    },
  };
  
  // ✅ Para mantener consistencia con lo que tenías
  export default API;